// extracted by mini-css-extract-plugin
export default {"titleAndValueContainer":"RenderTitleAndValue_titleAndValueContainer__-mCLC","titleClass":"RenderTitleAndValue_titleClass__bkLtX","valueClass":"RenderTitleAndValue_valueClass__Lil9-"};